import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authApi = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  getMe: () => api.get('/auth/me'),
};

// Map Items API
export const mapItemsApi = {
  getActive: () => api.get('/map-items'),
  getAll: () => api.get('/map-items/all'),
  create: (data) => api.post('/map-items', data),
  update: (id, data) => api.put(`/map-items/${id}`, data),
  delete: (id) => api.delete(`/map-items/${id}`),
  toggle: (id) => api.patch(`/map-items/${id}/toggle`),
};

// Notifications API
export const notificationsApi = {
  getAll: () => api.get('/notifications'),
  create: (data) => api.post('/notifications', data),
  delete: (id) => api.delete(`/notifications/${id}`),
};

// Chat API
export const chatApi = {
  getRooms: () => api.get('/chat/rooms'),
  createRoom: (data) => api.post('/chat/rooms', data),
  getMessages: (roomId) => api.get(`/chat/rooms/${roomId}/messages`),
  sendMessage: (data) => api.post('/chat/messages', data),
  markRead: (msgId) => api.post(`/chat/messages/${msgId}/read`),
};

// Users API
export const usersApi = {
  getAll: () => api.get('/users'),
  getPersonnel: () => api.get('/users/personnel'),
  // Admin-only user management
  create: (data) => api.post('/admin/users', data),
  update: (id, data) => api.put(`/admin/users/${id}`, data),
  delete: (id) => api.delete(`/admin/users/${id}`),
};

// Departments API
export const departmentsApi = {
  getAll: () => api.get('/departments'),
  create: (data) => api.post('/admin/departments', data),
  delete: (id) => api.delete(`/admin/departments/${id}`),
};

// Callouts API
export const calloutsApi = {
  getAll: () => api.get('/callouts'),
  create: (data) => api.post('/callouts', data),
  acknowledge: (id) => api.post(`/callouts/${id}/acknowledge`),
  delete: (id) => api.delete(`/callouts/${id}`),
};

// Stats API
export const statsApi = {
  get: () => api.get('/stats'),
};

export default api;
